import React from "react";
import { Container } from "react-bootstrap";
import "./ContactBanner.css";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { BsShop,BsClock } from "react-icons/bs";
const ContactBanner = () => {
  return (
    <div className="contact-banner">
      <div className="contact-banner-img">
        <img
          src={require("../../../images/offer/offer4.jpg")}
          alt=""
          className="h-100 w-100"
        />
      </div>
      <Container>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8">
            <div className="contact-text-left">
              <div className="section-heading">
                <span>Contact With Us</span>
                <h2>Get In Touch</h2>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Veritatis commodi pariatur ut provident <br /> ipsam ipsum in
                  voluptates vitae id beatae. Vitae illum corporis perspiciatis
                  qui.
                </p>
              </div>
              <Form noValidate>
                <Row className="mb-3">
                  <Form.Group as={Col} md="6" controlId="validationCustom01">
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="First name"
                      defaultValue="Mark"
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6" controlId="validationCustom02">
                    <Form.Label>Your Email</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Last name"
                      defaultValue="Otto"
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom03">
                    <Form.Label>Your Subject</Form.Label>
                    <Form.Control type="text" placeholder="Your Subject" />
                    <Form.Control.Feedback type="invalid">
                      Please provide a valid city.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="12" controlId="validationCustom04">
                    <Form.Label>Your words here</Form.Label>
                    <Form.Control
                      rows={4}
                      as="textarea"
                      placeholder="Leave a comment here"
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a valid state.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Form.Group className="mb-3">
                  <Form.Check
                    required
                    label="Agree to terms and conditions"
                    feedback="You must agree before submitting."
                    feedbackType="invalid"
                  />
                </Form.Group>
                <Button variant="light" type="submit">Submit form</Button>
              </Form>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3">
            <div className="contact-text-right">
              <div>
                <h5 className="fw-light">
                  <BsShop className="me-2" /> Gen Apparel
                </h5>
                <span className="ms-2 text-secondary d-block">
                  Peacy Park Khanika, 3-42, Zoo Road
                </span>
                <span className="ms-2 text-secondary d-block">
                  Mirpur, Dhaka
                </span>
                <div className="mt-3">
                  <span className="ms-2 text-secondary d-block">
                    Email : genapparel@gmail.com
                  </span>
                  <span className="ms-2 text-secondary d-block">
                    Phone : 01714-330003
                  </span>
                </div>
              </div>
              <div className="mt-3">
                <h5 className="fw-light">
                  <BsClock className="me-2" /> Opening Hours
                </h5>
                <span className="ms-2 text-secondary d-block">
                  Peacy Park Khanika, 3-42, Zoo Road
                </span>
                <span className="ms-2 text-secondary d-block">
                  Mirpur, Dhaka
                </span>
                <div className="mt-3">
                  <span className="ms-2 text-secondary d-block">
                    Email : genapparel@gmail.com
                  </span>
                  <span className="ms-2 text-secondary d-block">
                    Phone : 01714-330003
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ContactBanner;
